<template>
  <div>
    <div class="content">
      <!--      <div class="content-main">-->
      <!--        <p class="content-title">用户权限</p>-->
      <!--      </div>-->
      <div class="content-main">
        <p class="content-title" style="padding-bottom: 16px;">阿里账号</p>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; padding-bottom: 12px;"
              v-loading="loading"
              size="default"
          >
            <el-table-column property="appId" label="appId"/>
            <el-table-column property="remark" label="备注"/>
            <el-table-column property="" label="打款账号">
              <template #default="scope">
                <p><span :style="{color: scope.row.payState == 1?'#409eff':''}">{{scope.row.payState == 1?'是':'否'}}</span></p>
              </template>
            </el-table-column>
            <el-table-column property="" label="收款">
              <template #default="scope">
                <span v-if="scope.row.state == 1" style="color: #409eff;">默认收款账号</span>
                <span v-else-if="scope.row.packageNameList">
                  <div v-for="item in scope.row.packageNameList" :key="item.id">
                    {{ item.packageName }}
                  </div>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template #default="scope">
                <el-button type="primary" v-if="scope.row.state != 1" @click="payeeSetting(scope.row)" size="small">包名收款设置</el-button>
                <el-button type="warning" v-if="scope.row.payState==2 || scope.row.payState==0" @click="updatePayState(scope.row)" size="small">设为打款账号</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData } from "@/api/api";
import { getAlipayPayAllList, updateAlipayState } from "@/api/url";
import Dialog from "@/assets/js/dialog";
import payeeSettingDialog from "./components/payeeSettingDialog";

export default {
  name: "Alipay",
  data() {
    return {
      pageDataList: [],
      loading: false,
    }
  },
  methods: {

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    getPage() {
      this.loading = true
      let param = {};
      getFormData(getAlipayPayAllList, param).then((data)=>{
        let {msg, code} = data
        if (code == 200) {
          this.pageDataList = data.data
        }else {
          this.$message({
            message: msg,
            type: 'warning',
            duration: 1000,
          })
        }
        this.loading = false
      }).catch((err) => {
        this.loading = false
        this.$message({
          message: err.msg,
          type: 'warning',
          duration: 1000
        })
      })
    },

    updatePayState(row) {
      this.$confirm('确定要设置【' + row.remark + '】为打款账号？').then(() => {
        postFormData(updateAlipayState, { id: row.id }).then((data) => {
          let { code, msg } = data;
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message:msg,
              type: 'success'
            });
            this.getPage()
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message:msg,
              type: 'error'
            });
          }
          this.loading = false;
        })
      }).catch(()=> {});
    },

    payeeSetting(row) {
      let otherCheckedIdArr = [];
      for(let item of this.pageDataList) {
        if(item.id != row.id && item.packageNameList) {
          for(let pn of item.packageNameList) {
            otherCheckedIdArr.push(pn.id);
          }
        }
      }

      Dialog.open({
        title: row.remark + ' 账号收款设置',
        component: payeeSettingDialog,
        data: {
          alipayForm: Object.assign({}, row),
          otherCheckedIdArr: otherCheckedIdArr,
          width: '800px'
        },
        confirm: (result) => {
            this.getPage()
        }
      })
    },


  },
  mounted() {
    this.getPage();
  }
}
</script>

<style scoped>
.el-table {
  --el-table-header-bg-color: #ffffff !important;
}
</style>
